const fullDisplayName = user =>
  `${user?.first_name ?? ""} ${user?.last_name ?? ""}`.trim();

export { fullDisplayName };
